/**
 * Select 스타일
 * @description `Input` 과 같은 토큰을 읽어 두 필드가 한 화면에 서도 어긋나지 않게 한다.
 */
import { cva } from "class-variance-authority";

export const selectStyles = {
  root: "flex w-full flex-col",
  label: cva("fw-l2 mb-[var(--fw-input-gap-label)]", {
    variants: {
      disabled: {
        true: "text-[var(--fw-input-color-content-label-disabled)]",
        false: "",
      },
      error: {
        true: "text-[var(--fw-input-color-content-label-error)]",
        false: "text-[var(--fw-input-color-content-label-rest)]",
      },
    },
    compoundVariants: [
      {
        disabled: true,
        error: true,
        class: "text-[var(--fw-input-color-content-label-disabled)]",
      },
    ],
    defaultVariants: { disabled: false, error: false },
  }),
  trigger: cva(
    [
      "flex w-full cursor-pointer items-center text-left",
      "gap-[var(--fw-input-gap-field)]",
      "px-[var(--fw-input-padding-field-horizontal)]",
      "py-[var(--fw-input-padding-field-vertical)]",
      "rounded-[var(--fw-input-radius)] focus-visible:outline-none",
    ],
    {
      variants: {
        disabled: {
          true: "cursor-not-allowed bg-[var(--fw-input-color-surface-disabled)] shadow-[inset_0_0_0_var(--fw-input-stroke-width-rest)_var(--fw-input-color-stroke-disabled)]",
          false: "",
        },
        error: {
          true: "bg-[var(--fw-input-color-surface-rest)] shadow-[inset_0_0_0_var(--fw-input-stroke-width-pressed)_var(--fw-input-color-stroke-error)]",
          false:
            "bg-[var(--fw-input-color-surface-rest)] shadow-[inset_0_0_0_var(--fw-input-stroke-width-rest)_var(--fw-input-color-stroke-rest)] focus-visible:shadow-[inset_0_0_0_var(--fw-input-stroke-width-pressed)_var(--fw-input-color-stroke-focused)]",
        },
      },
      defaultVariants: { disabled: false, error: false },
    },
  ),
  value: cva("fw-b1 min-w-0 flex-1 truncate", {
    variants: {
      filled: {
        true: "text-[var(--fw-input-color-content-field-filled)]",
        false: "text-[var(--fw-input-color-content-field-rest)]",
      },
      disabled: {
        true: "text-[var(--fw-input-color-content-field-disabled)]",
        false: "",
      },
    },
    defaultVariants: { filled: false, disabled: false },
  }),
  chevron: "shrink-0 text-[var(--fw-input-color-content-field-rest-icon)]",
  helper: cva("fw-caption mt-[var(--fw-input-gap-helper)]", {
    variants: {
      disabled: {
        true: "text-[var(--fw-input-color-content-helper-disabled)]",
        false: "",
      },
      error: {
        true: "text-[var(--fw-input-color-content-helper-error)]",
        false: "text-[var(--fw-input-color-content-helper-rest)]",
      },
    },
    compoundVariants: [
      {
        disabled: true,
        error: true,
        class: "text-[var(--fw-input-color-content-helper-disabled)]",
      },
    ],
    defaultVariants: { disabled: false, error: false },
  }),
};
